import React, { useState, useEffect } from "react";
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from "react-icons/fa";
import "./contactpage.css";
import AOS from "aos";
import "aos/dist/aos.css";

function Contactpage() {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        mobile: "",
        message: ""
    });

    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: true,
            easing: "ease-out"
        });
    }, []);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const sendWhatsApp = (e) => {
        e.preventDefault();
        const { name, email, mobile, message } = formData;
        const phoneNumber = "918778934301";

        const text = `Hello, I would like to contact you regarding my website-related details:
Name: ${name}
Email: ${email}
Mobile: ${mobile}
Message: ${message}`;

        const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(text)}`;
        window.open(whatsappURL, "_blank");
    };

    return (
        <>
            <center>
                <section className="section-margin" data-aos="fade-down">
                    <div className="heading-for-all" data-aos="fade-up">
                        <h2>Contact Us</h2>
                    </div>
                </section>
            </center>

            <div className="contact-container">
                <div className="contact-box">
                    {/* Left Section */}
                    <div className="contact-left" data-aos="fade-up" data-aos-delay="100">
                        <div className="contact-info">
                            <FaMapMarkerAlt className="contact-icon" />
                            <h3>Address</h3>
                            <p>No:21, Vinayaga Street</p>
                            <p>Okkiyam, Thoraipakkam</p>
                            <p>Chennai - 600097</p>
                        </div>

                        <div className="contact-info">
                            <FaPhoneAlt className="contact-icon" />
                            <h3>Phone</h3>
                            <p>+91 87789 34301</p>
                        </div>

                        <div className="contact-info">
                            <FaEnvelope className="contact-icon" />
                            <h3>Email</h3>
                            <p>eletiaa.com@gmail.com</p>
                            <p>info@eletiaa.com</p>
                        </div>
                    </div>

                    {/* Right Section */}
                    <div className="contact-right" data-aos="fade-up" data-aos-delay="200">
                        <h2>Send us a message</h2>
                        <p>
                            If you have any work from me or any types of queries related to my
                            tutorial, you can send me a message from here. It's my pleasure to help you.
                        </p>

                        <form className="contact-form" onSubmit={sendWhatsApp}>
                            <input
                                type="text"
                                name="name"
                                placeholder="Your Name"
                                value={formData.name}
                                onChange={handleChange}
                                required
                            />
                            <input
                                type="email"
                                name="email"
                                placeholder="Your Email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                            />
                            <input
                                type="number"
                                name="mobile"
                                placeholder="Your Mobile"
                                value={formData.mobile}
                                onChange={handleChange}
                                required
                            />
                            <textarea
                                name="message"
                                placeholder="Enter your message"
                                rows="5"
                                value={formData.message}
                                onChange={handleChange}
                                required
                            ></textarea>
                            <button className="choose-plan-btn">Send Now</button>
                        </form>
                    </div>  
                </div>
            </div>
        </>
    );
}

export default Contactpage;
